import * as types from '../types';
import { IStarterTemplatesApi } from '../contracts';
import { HttpApi } from './HttpApi';

type Res<T> = types.APIResponse<T>;

export class StarterTemplatesHttpApi extends HttpApi implements IStarterTemplatesApi {
  async listStarterPacks(): Promise<types.StarterPackSummary[]> {
    return (await this.http.get<Res<types.StarterPackSummary[]>>('/starter-templates')).data.data;
  }

  async getStarterPack(packKey: types.StarterPackKey): Promise<types.StarterPack> {
    return (await this.http.get<Res<types.StarterPack>>(`/starter-templates/${encodeURIComponent(packKey)}`)).data.data;
  }

  async previewStarterPack(packKey: types.StarterPackKey): Promise<types.StarterPreviewResponse> {
    return (await this.http.post<Res<types.StarterPreviewResponse>>(`/starter-templates/${encodeURIComponent(packKey)}/preview`)).data.data;
  }

  async applyStarterPack(packKey: types.StarterPackKey): Promise<types.StarterApplyResponse> {
    return (await this.http.post<Res<types.StarterApplyResponse>>(`/starter-templates/${encodeURIComponent(packKey)}/apply`)).data.data;
  }

  async listSeededStarterRecords(): Promise<types.SeededRecordsResponse> {
    return (await this.http.get<Res<types.SeededRecordsResponse>>('/starter-templates/seeded')).data.data;
  }

  async keepStarterRecord(seededId: string): Promise<types.StarterKeepResponse> {
    return (await this.http.delete<Res<types.StarterKeepResponse>>(`/starter-templates/seeded/${encodeURIComponent(seededId)}`)).data.data;
  }

  async removeUnusedStarterRecords(packKey: types.StarterPackKey): Promise<types.StarterRemoveResponse> {
    return (await this.http.delete<Res<types.StarterRemoveResponse>>(`/starter-templates/applied/${encodeURIComponent(packKey)}`)).data.data;
  }
}
